import { render, staticRenderFns } from "./NuxStepMedia.vue?vue&type=template&id=694b4712&scoped=true&"
import script from "./NuxStepMedia.vue?vue&type=script&lang=ts&"
export * from "./NuxStepMedia.vue?vue&type=script&lang=ts&"
import style0 from "./NuxStepMedia.vue?vue&type=style&index=0&id=694b4712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694b4712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('694b4712', component.options)
    } else {
      api.reload('694b4712', component.options)
    }
    module.hot.accept("./NuxStepMedia.vue?vue&type=template&id=694b4712&scoped=true&", function () {
      api.rerender('694b4712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/nux/components/NuxStepMedia.vue"
export default component.exports